import { InformacionBasicaEspacio } from '../modulos/lugares/detalle-espacio/detalle-espacio.component';
import { ResultadoServicio } from './lugares.service';
import { DataLogin } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import * as moment from 'moment';


const smartHomeUrl = 'https://as-ws-smarthome.azurewebsites.net/';
@Injectable({
  providedIn: 'root'
})
export class EspaciosService {

  constructor(
    private _http: HttpClient
  ) { }

  getEspacios(page: number): Observable<Unidad> {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));

    const requestUrl = `${smartHomeUrl}api/unidades/unidad/${loginData.company_id}?page=${page + 1}&cant=12`;

    let headers = new HttpHeaders({
      'dataEspacios': 'true'
    });

    return this._http.get<Unidad>(requestUrl, { headers });
  }

  getImagenesEspacio(idEspacio: string): Observable<ResultadoServicio<Imagenes>> {
    const requestUrl = `${smartHomeUrl}api/lugares/${idEspacio}/imagenes`;

    return <Observable<ResultadoServicio<Imagenes>>> this._http.get(requestUrl);
  }

  actualizarImagenesEspacio(idSitioEspacio: number, imagenes: Imagen[]): Observable<any> {
    const requestUrl = `${smartHomeUrl}api/lugares/imagen`;
    const actualizaciones = [];

    imagenes.forEach(imagen => {
      if(imagen.file) {
        const formData = new FormData();
        formData.append('imagenLugar', imagen.file);
        formData.append('s_id', String(idSitioEspacio));

        actualizaciones.push(this._http.post(requestUrl, formData)
        .pipe(
          map((res: NuevaImagenResponse) => {
              const imagenConId: Imagen = {
                ...imagen,
                id: res.data.imagen_id,
                s_id: idSitioEspacio
              };

              delete imagenConId.file;
              
              return imagenConId;
            })
          ));
      } else if(imagen.eliminada && imagen.id) {
        actualizaciones.push(this._http.delete(requestUrl + "/" + imagen.id));
      }
    })

    return forkJoin(actualizaciones);
  }

  actualizarHorarios(siteId: number, valoresInicialesHorarios: Map<number, Horario>, horariosExistentes: Map<number, FormGroup>, nuevosHorarios: FormGroup[]): Observable<any> {
    const actualizaciones = [];
    let headers = new HttpHeaders({
      'dataHorario': 'true'
    });

    valoresInicialesHorarios.forEach(horario => {
      const idHorario = horario["id"];
      const formularioHorarioActualValor = horariosExistentes.get(idHorario).value;

      const haCambiado = Object.keys(horario).some(key => formularioHorarioActualValor[key] != horario[key]);
      const fueEliminado = formularioHorarioActualValor["eliminado"];

      const requestUrl = `${smartHomeUrl}api/lugares/horario/${idHorario}`;

      if(fueEliminado) actualizaciones.push(this._http.delete(requestUrl));
      else if(haCambiado) actualizaciones.push(this._http.patch(requestUrl, formularioHorarioActualValor, { headers }));
    });

    nuevosHorarios.forEach(horario => {
      const requestUrl = `${smartHomeUrl}api/lugares/horario`;
      const body = horario.value;
      const fueEliminado = body["eliminado"];

      body["s_id"] = siteId;

      if(!fueEliminado) {
        actualizaciones
          .push(this._http.post(requestUrl, body)
          .pipe(
            map((res: NuevoHorarioResponse) => {
              const horarioConId = horario;
              horarioConId.get("id").setValue(res.data.horario_id);
  
              return {
                nuevoHorario: true,
                horario: horarioConId
              };
            })
          ));
      }
    });

    return forkJoin(actualizaciones);
  }

  actualizarInformacionBasica(idLugar: string, infoBasica: InformacionBasicaEspacio): Observable<ActualizarInformacionBasicaEspacioResponse> {
    const requestUrl = `${smartHomeUrl}api/lugares/lugar/${idLugar}`;
    const headers = new HttpHeaders({
      'dataLugar': 'true'
    });

    const body = {
      description: infoBasica.descripcion,
      status: infoBasica.estado
    }

    return <Observable<ActualizarInformacionBasicaEspacioResponse>>this._http.patch(requestUrl, body, { headers });
  }

  traerHorariosEspacio(idEspacio: string): Observable<HorariosResponse> {
    const requestUrl = `${smartHomeUrl}api/lugares/${idEspacio}/horarios`;

    return <Observable<HorariosResponse>> this._http.get(requestUrl);
  }
  
  traerReservasEspacios(palabrasClave: string, idEspacio: number) {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    const requestUrl = `${smartHomeUrl}api/reservas/${loginData.company_id}?key=${palabrasClave}${idEspacio ? `&espacioId=${idEspacio}` : ''}`;

    return <Observable<Cita[]>> this._http.get(requestUrl).pipe(
      map((res: RespuestaReservas) => {
        return res.data.reservas.map(reserva => {
          const someDay = moment(reserva.date);
          const horaInicio = parseInt(reserva.date_begin.split(":")[0]);
          const horaFin = parseInt(reserva.date_end.split(":")[0]);
          someDay.set({
            hour: parseInt(reserva.date_begin.split(":")[0])
          });

          const duracion = (horaFin - horaInicio)*60;
          return {
            fechaHora: someDay.format("DD/MM/YYYY hh:mm a"),
            duracion,
            nombre: reserva.site_name,
            persona: reserva.owner_name
          };
        });
      })
    );;
  }
}

export interface Cita {
  fechaHora: string,
  duracion: number,
  nombre?: string
}
export interface Reserva {
  date: string;
  date_begin: string;
  date_end: string;
  status: number;
  place_admon_cost: number;
  site_name: string;
  owner_name: string;
}
export interface RespuestaReservas {
  data: {
    reservas: Reserva[]
  }
}
export interface ActualizarInformacionBasicaEspacioResponse {
  data: {
    lugar: InformacionBasicaEspacio
  }
}

export interface Imagenes {
  imagenes: Imagen[]
}
export interface Imagen {
  id?: number;
  s_id?: number;
  url_imagen: string;
  estado?: number;
  file?: File;
  eliminada?: boolean;
}

export interface Unidad {
  data: EspaciosUnidad;
}

export interface EspaciosUnidad {
  lugares: InformacionEspacio[];
}

export interface InformacionEspacio {
  area_id: number;
  area_name: string;
  class_id: number;
  company_id: number;
  id: number;
  site_id: number;
  site_name: string;
  type: string;
  picture: string;
}

export interface HorariosResponse {
  data: {
    horarios: Horario[]
  }
}

export interface Horario {
  id: number,
  descripcion: string,
  dia: number,
  hora_desde: string,
  hora_hasta: string,
  valor: number,
  estado: number
}

export interface NuevoHorarioResponse {
  data: {
    horario_id: number
  }
}

export interface NuevaImagenResponse {
  data: {
    imagen_id: number
  }
}
